/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { computed } from '@ember/object';
import { isNone } from '@ember/utils';
import { DAYS, DAY_ITEMS, daysToSet, dayItemValue } from 'cio/utils/delivery-window';
import TIMES from 'cio/utils/times';
import { CUSTOMER_TIME_ZONE } from 'cio/utils/time-zones';
import ActionModel from 'cio/models/action';

function computedActionTime(actionKey: string) {
  return computed(`args.action.${actionKey}`, function () {
    let value = this.args.action[actionKey];
    let time = TIMES.findBy('value', value);

    return time?.label ?? value;
  });
}

interface CioActionWindowInfoArgs {
  action: ActionModel;
}

export default class CioActionWindowInfo extends Component<CioActionWindowInfoArgs> {
  @computed('args.action.days')
  get formattedDays() {
    let days = daysToSet(this.args.action.days);
    let item = DAY_ITEMS.findBy('value', dayItemValue(days));

    if (isNone(item) || item.value === 'specific') {
      return DAYS.filter((day) => days[day]).join(', ');
    }

    return item.label;
  }

  @computedActionTime('startTime')
  startTime!: string;

  @computedActionTime('endTime')
  endTime!: string;

  customerTimeZone = CUSTOMER_TIME_ZONE;
}
